import React from "react";
import Table from "./UserProfileTable";

const UserProfile = () => {
  return (
    <>
      <div >
        <Table />
      </div>
    </>
  );
};

export default UserProfile;
